<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div *ngIf="back_flag" style="position: fixed;
background: white;
top: 16px;
left: 6px;">
   <div style="display: flex;
   gap: 10px;
   font-size: 16px;
   cursor: pointer;" (click)="navigateToMaster()">
      <img src="../../../assets/images/arrow.png" alt="">
      <span>Back</span>
   </div>
</div>
<div class="container">
   <div class="row titleFont" style="margin-top:2% ;">
      <div class="col-md-6">
         <span>
            Restaurant Details
         </span>
      </div>
      <div class="col-md-6">
         <img style="height: 40px;width: 40px;" [src]="logo" #img>
      </div>
   </div>
   <div class="row titleFont padd3">
      <div class="col-md-6">
         <span>
            Restaurant Name : <span class="clrtitle"> {{rstoName}}</span>
         </span>
      </div>
      <div class="col-md-6">
         <span>
            Restaurant ID : <span class="clrtitle">{{rstoID}}</span>
         </span>
      </div>
   </div>
   <div class="row titleFont padd3">
      <div class="col-md-6">
         <span>
            Restaurant Address : <span class="clrtitle">{{rstoAdd}}</span>
         </span>
      </div>
      <div class="col-md-6">
         <span>
            POC Name : <span class="clrtitle"> {{rstopocName}}</span>
         </span>
      </div>
   </div>
   <div class="row titleFont padd3">
      <div class="col-md-6">
         <span>
            POC ID : <span class="clrtitle"> {{pocID}}</span>
         </span>
      </div>
      <div class="col-md-6">
         <span>
            Email : <span class="clrtitle"> {{rstoEmail}}</span>
         </span>
      </div>
   </div>
   <div class="row titleFont padd3 paddbottom3">
      <div class="col-md-6">
         <span>
            Service Charge (%) : <span class="clrtitle"> {{restaurant_service_charge}}</span>
         </span>
      </div>
      <div class="col-md-6">
         <span>
            Coupon Value (%) : <span class="clrtitle"> {{restaurant_coupan_value}}</span>
         </span>
      </div>
   </div>

   <div class="row titleFont padd3 paddbottom3">
      <div class="col-md-4">
         <span>
            Food Dishes & Ingredient & Allergies
         </span>
      </div>
      <!-- TOOLBAR -->
      <div class="toolbar">
         <button for="file-upload" [tcBgColor]="'#2e7d32'" [tcColor]="'#fff'" tc-button class="btn-primary" (click)="downloadTemplate()">
            Download CSV template
         </button>

         <button for="file-upload" tc-button [tcBgColor]="'#3949ab'" [tcColor]="'#fff'"
            (click)="openModalFile(modalHeaderfile, modalBodyfile, modalFooterfile)">
            Upload CSV template
         </button>

         <!-- QR Dropdown -->
         <div class="dropdownish" #dropdownRefQr>
            <button type="button" class="dropdownish-toggle qr-toggle" (click)="toggleQrDropdown()" aria-haspopup="menu"
               [attr.aria-expanded]="showQROption ? 'true' : 'false'">
               Download QR Code
            </button>
            <div class="dropdownish-menu" *ngIf="showQROption" role="menu">
               <div class="dropdownish-item" role="menuitem" (click)="downLoadQrWeb(true)">Only QR Code</div>
               <div class="dropdownish-item" role="menuitem" (click)="downLoadQrWeb()">QR Code Card</div>
            </div>
         </div>

         <button tc-button [tcBgColor]="'#00897b'" [tcColor]="'#fff'" (click)="addNewDish()">
            Add New Dish
         </button>

         <button tc-button [tcBgColor]="'#ef6c00'" [tcColor]="'#fff'" (click)="openAllergenChart()">
            Allergen Chart
         </button>

         <button tc-button [tcBgColor]="'#5e35b1'" [tcColor]="'#fff'" (click)="openUnsutaibleDPChart()">
            Unsuitable DP Chart
         </button>

         <!-- Menu Link dropdown (shown only if qrCodeDownload) -->
         <div class="dropdownish" *ngIf="qrCodeDownload" #dropdownRef>
            <button type="button" class="dropdownish-toggle menu-toggle" (click)="toggleDropdown()" aria-haspopup="menu"
               [attr.aria-expanded]="showMenuLinkOption ? 'true' : 'false'">
               Menu Link
            </button>
            <div class="dropdownish-menu" *ngIf="showMenuLinkOption" role="menu">
               <div class="dropdownish-item" role="menuitem" (click)="openFoodMenu()">Open in new tab</div>
               <div class="dropdownish-item" role="menuitem" (click)="copyFoodMenuLink()">Copy Link</div>
            </div>
         </div>

         <button tc-button *ngIf="qrCodeDownload" [tcBgColor]="'#101112'" [tcColor]="'#fff'" (click)="addMenuName()">
            Menu Label
         </button>

         <button tc-button [tcBgColor]="'#aea91d'" [tcColor]="'#fff'" (click)="showMenu()">
            Menu
         </button>

         <button tc-button [tcBgColor]="'#c62828'" [tcColor]="'#fff'" (click)="deleteAllDish()">
            Delete Entire Menu
         </button>

         <button tc-button [tcBgColor]="'#1565c0'" [tcColor]="'#fff'" (click)="toggleMultiSelect()">
            {{ multiSelectMode ? 'Cancel Multi Delete' : 'Delete Multi Dishes' }}
         </button>

         <button tc-button [tcBgColor]="'#b71c1c'" [tcColor]="'#fff'" [disabled]="selectedIds.size === 0"
            (click)="deleteSelected()" *ngIf="multiSelectMode">
            Delete selected ({{ selectedIds.size }})
         </button>
      </div>


   </div>

   <div class="menu_label_selection_main_div" *ngIf="!isDefaultMenu">
      <div class="menu_label_txt">Menu Label</div>
      <select class="form-select menu_label_select" (change)="changeDisheTableMenu($event.target.value)"
         [(ngModel)]="selectedMenuName">
         <option *ngFor="let menuName of allActiveMenuName;let i=index" [value]="menuName.id">
            {{menuName.dish_menu_name}}
         </option>
      </select>
   </div>
   <!-- <div class="mb-2 flex items-center gap-2 dishDeleteMainDiv">
      <button tc-button [tcBgColor]="'#d32f2f'" [tcColor]="'#fff'" style="margin-top: 0px;" (click)="deleteAllDish()">
         Delete Entire Menu
      </button>

      <button tc-button [tcBgColor]="'#0288d1'" [tcColor]="'#fff'" (click)="toggleMultiSelect()"
         style="margin-top: 0px;">
         {{ multiSelectMode ? 'Cancel Multi Delete' : 'Delete Multi Dishes' }}
      </button>

      <button tc-button [tcBgColor]="'#d32f2f'" [tcColor]="'#fff'" [disabled]="selectedIds.size === 0"
         (click)="deleteSelected()" *ngIf="multiSelectMode" style="margin-top: 0px;">
         Delete selected ({{ selectedIds.size }})
      </button>
   </div> -->

   <tc-card class="mb-0">
      <tc-table #tbl [rows]="restoDeatils" [search]="true" [hovered]="true" [pagination]="true"
         [headerBgColor]="'#fb8033'" [headerColor]="'#ffffff'" [headerBgColor]="'#3e51b5'" [searchValue]="searchTerm"
         (searchValueChange)="searchTerm = $event">


         <!-- S.No. when NOT in multi-select -->
         <tc-table-col *ngIf="!multiSelectMode" [columnTitle]="'S.No.'" [columnName]="'serial'">
            <ng-template #tableTDTemplate let-value>
               <span>{{ value }}</span>
            </ng-template>
         </tc-table-col>

         <!-- Select column when in multi-select -->
         <tc-table-col *ngIf="multiSelectMode" [columnTitle]="'Select'" [columnName]="'__select__'"
            [enableSorting]="false">

            <ng-template #headerBodyTemplate>
               <div style="display: flex; flex-direction: column; align-items: center; min-width: 60px; color: #fff;">
                  <span>Select All</span>
                  <input type="checkbox" (click)="$event.stopPropagation()" [checked]="areAllChecked(tbl?.rows || [])"
                     (change)="toggleAllOnPage(tbl?.rows || [], $event.target.checked)">
               </div>
            </ng-template>

            <ng-template #tableTDTemplate let-value="row">
               <div style="display:flex; justify-content:center;">
                  <input type="checkbox" [checked]="value._checked === true"
                     (change)="onRowToggle(value, $event.target.checked)" />
               </div>
            </ng-template>
         </tc-table-col>

         <tc-table-col [columnTitle]="'Dish'" [columnName]="'image'">
            <ng-template #tableTDTemplate let-value>
               <tc-avatar [src]="value"></tc-avatar>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Unique ID'" [columnName]="'unique_id'">
            <ng-template #tableTDTemplate let-value>
               <strong>{{ value }}</strong>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Category'" [columnName]="'dish_type_name'">
            <ng-template #tableTDTemplate let-value>
               <span [tcColor]="'#a5a5a5'">{{ value }}</span>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Name'" [columnName]="'name'">
            <ng-template #tableTDTemplate let-value>
               <strong>{{ value }}</strong>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Price'" [columnName]="'price'">
            <ng-template #tableTDTemplate let-value>
               <span [tcColor]="'#a5a5a5'" #id>{{ value }}</span>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Allergens List'" [columnName]="'allergensWithComma'">
            <ng-template #tableTDTemplate let-value>
               <span class="nowrap">{{ value }}</span>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Unsuitable Dietary Preference'" [columnName]="'dpWithComma'">
            <ng-template #tableTDTemplate let-value>
               <span class="nowrap">{{ value }}</span>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Add On'" [columnName]="'id'">
            <ng-template #tableTDTemplate let-value="row">
               <button tc-button [afterIcon]="'icofont-plus'" [tcFontSize]="10" [tcBgColor]="'#64b5f6'" [square]="true"
                  [tcShape]="500" [size]="'sm'"
                  (click)="openModals_addon(Header_addon,Body_addon,{ closeButton: false, overlayClose: false , width: 900 },value.id)"></button>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Details'" [columnName]="'dpWithComma'">
            <ng-template #tableTDTemplate let-value="row">
               <button tc-button [afterIcon]="'icofont-eye-alt'" [tcFontSize]="10" [tcBgColor]="'#2f8c00'"
                  [square]="true" [tcShape]="500" [size]="'sm'"
                  (click)="openModalsView(modalBodyview, modalHeaderview,modalFooterview,{ width: 800 },value)"></button>
            </ng-template>
         </tc-table-col>

         <tc-table-col [columnTitle]="'Status'" [columnName]="'status'">
            <ng-template #tableTDTemplate let-value="row">
               <tc-switcher *ngIf="value.status=='Inactive'" [value]="false" [tcFontSize]="10" #templateForm
                  (click)="switch(value.status,value.id)"></tc-switcher>
               <tc-switcher *ngIf="value.status=='Active'" [tcFontSize]="10" [value]="true" #templateForm
                  (click)="switch(value.status,value.id)">
               </tc-switcher>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Customizable'" [columnName]="'status'">
            <ng-template #tableTDTemplate let-value="row">
               <tc-switcher style="font-size: 10px !important; " *ngIf="!value.is_customizable" [tcFontSize]="5"
                  [value]="false" #templateForm (click)="switchCustomize('Active',value.id)"></tc-switcher>
               <tc-switcher style="font-size: 10px !important; " *ngIf="value.is_customizable" [tcFontSize]="5"
                  [value]="true" #templateForm (click)="switchCustomize('Inactive',value.id)">
               </tc-switcher>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Recommended'" [columnName]="'status'">
            <ng-template #tableTDTemplate let-value="row">
               <tc-switcher *ngIf="!value.is_recommend" [value]="false" #templateForm
                  (click)="switchRecomanded('Active',value.id)"></tc-switcher>
               <tc-switcher *ngIf="value.is_recommend" [value]="true" #templateForm
                  (click)="switchRecomanded('Inactive',value.id)">
               </tc-switcher>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Media Upload'" [columnName]="'id'">
            <ng-template #tableTDTemplate let-value="row">
               <a
                  (click)="openModalImage(modalHeaderImage,modalBodyImage,{ closeButton: true, overlayClose: false , width: 500 },value)">
                  <mat-icon aria-hidden="false" aria-label=" filter icon" style="font-size: 30px; color: #000;">
                     create_new_folder</mat-icon>
               </a>
               <!-- <button tc-button [afterIcon]="'icofont-upload-alt'" [square]="true" [tcShape]="500" [size]="'sm'"
      [tcColor]="'#ffffff'" [tcBgColor]="'#262626'"
      (click)="openModalImage(modalHeaderImage, modalBodyImage,modalFooterImage,value)"></button> -->
            </ng-template>
         </tc-table-col>
         <!-- <tc-table-col class="nowrap" [columnTitle]="'Audio Upload'" [columnName]="'food_dishes_id'">
      <ng-template #tableTDTemplate let-value="row"> -->
         <!-- <button tc-button [afterIcon]="'icofont-upload-alt'" [square]="true" [tcShape]="500" [size]="'sm'"
         [tcColor]="'#ffffff'" [tcBgColor]="'#262626'"
         (click)="openModalAudio(modalHeaderaudio, modalBodyaudio,modalFooteraudio,value)"></button> -->
         <!-- <a (click)="openModalAudio(modalHeaderaudio, modalBodyaudio,modalFooteraudio,value)">
            <mat-icon aria-hidden="false" aria-label=" filter icon" style="font-size: 33px; color: #000;"
            >create_new_folder</mat-icon>
         </a>  
      </ng-template>
      </tc-table-col> -->
      </tc-table>
   </tc-card>
</div>
<ng-container>
   <ng-template #modalHeaderview>
      <h2 class="title">Dish Details</h2>
      <div class="actions nowrap">
         <button tc-button [afterIcon]="'icofont-ui-edit'" [view]="'info'" [tcFontSize]="10" [square]="true"
            [tcShape]="500" [size]="'sm'"
            (click)="openModals(modalBody, modalHeader,modalFooter,{ width: 900 },id)"></button>
         &nbsp; <button tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10" [view]="'error'" [square]="true"
            [tcShape]="500" [size]="'sm'" (click)="openModal(modalBody1, modalHeader1,modalFooter1,id)"></button>
      </div>
   </ng-template>
   <ng-template #modalBodyview>
      <form novalidate #heroForm="ngForm" class="new-patient-form">
         <div class="row">
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Dish Name</label>
                  <tc-input disabled [placeholder]="'Name'" [(ngModel)]="food_dishes_name"
                     [ngModelOptions]="{standalone: true}" required>
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Dish Price</label>
                  <tc-input disabled [placeholder]="'Dish Price'" [type]="'number'" [(ngModel)]="food_dishes_price"
                     [ngModelOptions]="{standalone: true}" required></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Spice Rating</label>
                  <tc-input disabled [placeholder]="'Spice Rating'" [type]="'number'"
                     [(ngModel)]="food_dishes_spice_rating" [ngModelOptions]="{standalone: true}"></tc-input>
               </tc-form-group>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <tc-form-group> <label for="food_dishes_name" class="fnt-wght">Calories</label>
                  <tc-input disabled [placeholder]="'Calories'" [type]="'number'" [(ngModel)]="food_dishes_calories"
                     [ngModelOptions]="{standalone: true}"></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Allergens</label>
                  <tc-input disabled [placeholder]="'Allergens'" [type]="'text'" [(ngModel)]="allergens_words"
                     [ngModelOptions]="{standalone: true}" disabled></tc-input>
               </div>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Unsuitable Dietary Preference</label>
                  <tc-input disabled [placeholder]="'Dietary Preference'" [type]="'text'" [(ngModel)]="dietpreference"
                     [ngModelOptions]="{standalone: true}"></tc-input>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <tc-form-group> <label for="allergeOp" class="fnt-wght">Allergens Options</label>
                  <tc-input disabled [placeholder]="'Allergens Options'" [(ngModel)]="allergeOp"
                     [ngModelOptions]="{standalone: true}"></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group> <label for="dietPrefOp" class="fnt-wght">Dietary Preference Options</label>
                  <tc-input disabled [placeholder]="'Dietary Preference Options'" [(ngModel)]="dietPrefOp"
                     [ngModelOptions]="{standalone: true}">
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group> <label for="tagview" class="fnt-wght">Tags</label>
                  <tc-input disabled [placeholder]="'Tags'" [(ngModel)]="tagview" [ngModelOptions]="{standalone: true}">
                  </tc-input>
               </tc-form-group>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <tc-form-group class="mb-0 paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Last Update</label>
                  <tc-textarea type="text" disabled="disabled" [placeholder]="'last updated'" [(ngModel)]="last_update"
                     [ngModelOptions]="{standalone: true}">
                  </tc-textarea>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group class="mb-0 paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Ingredients</label>
                  <tc-textarea type="text" disabled="disabled" [placeholder]="'Ingredients'" [(ngModel)]="ingredience"
                     [ngModelOptions]="{standalone: true}">
                  </tc-textarea>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group class="mb-0" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Description</label>
                  <tc-textarea type="text" disabled="disabled" [placeholder]="'Description'" [(ngModel)]="description"
                     [ngModelOptions]="{standalone: true}">
                  </tc-textarea>
               </tc-form-group>
            </div>
            <div class="col-md-4">
            </div>
         </div>
         <h4>Options</h4>
         <div align="center" *ngIf="options.length== 0">
            <p style="color: #bdbdbd; font-weight: 600;">Options not found</p>
         </div>
         <div class="row" *ngIf="options.length != 0">
            <div class="col-md-4" *ngFor="let option of options">
               <tc-form-group> <label for="option.option_price"
                     class="fnt-wght">{{option.option_name}}( £ )</label>
                  <tc-input disabled [placeholder]="'Price'" [(ngModel)]="option.option_price"
                     [ngModelOptions]="{standalone: true}"></tc-input>
               </tc-form-group>
            </div>
         </div>
         <h4>Add ons</h4>
         <div align="center" *ngIf="addons.length == 0">
            <p style="color: #bdbdbd; font-weight: 600;">Add ons not found</p>
         </div>
         <div class="row" *ngIf="addons.length !=0">
            <div class="col-md-4" *ngFor="let item of addons">
               <tc-form-group> <label for="item.addon_name" class="fnt-wght">{{item.addon_name}}(
                     £ )</label>
                     <div *ngFor="let op of item?.options" style="margin-bottom: 2px;display: grid;grid-template-columns: 1fr 4fr;align-items: center;gap: 10px;">
                        <label for="op.dish_addon_option_price" class="fnt-wght" style="margin: 0;font-weight: 300;font-size: 12px;">{{op.option_name}}: </label>
                        <tc-input disabled [placeholder]="'Price'" [(ngModel)]="op.dish_addon_option_price"
                           [ngModelOptions]="{standalone: true}"></tc-input>
                     </div>
                     
               </tc-form-group>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #modalFooterview>
      <div class="actions justify-content-between">
         <button tc-button [type]="'button'" [view]="'error'" (click)="closeModalView()">Close</button>
         <!-- <button tc-button [view]="'info'"
            [disabled]="!food_dishes_name || !food_dishes_price || !food_dishes_category_id"
              (click)="updateList(food_dishes_name,food_dishes_price,food_dishes_spice_rating,food_dishes_calories,food_dishes_category_id,algns,dietPref,ingredience,description)">
              Update
            </button> -->
      </div>
   </ng-template>

</ng-container>
<ng-container>
   <ng-template #modalHeader>
      <h2 class="title">Update Dish Details</h2>
   </ng-template>
   <ng-template #modalBody>
      <form novalidate #heroForm="ngForm" class="new-patient-form">
         <div class="row">
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Dish Name</label>
                  <tc-input [placeholder]="'Name'" [(ngModel)]="food_dishes_name" [ngModelOptions]="{standalone: true}"
                     required>
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Dish Price</label>
                  <tc-input [placeholder]="'Dish Price'" [type]="'number'" [(ngModel)]="food_dishes_price"
                     [ngModelOptions]="{standalone: true}" required></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="food_dishes_name" class="fnt-wght">Spice Rating</label>
                  <tc-input [placeholder]="'Spice Rating'" [type]="'number'" [(ngModel)]="food_dishes_spice_rating"
                     [ngModelOptions]="{standalone: true}"></tc-input>
               </tc-form-group>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <tc-form-group> <label for="food_dishes_name" class="fnt-wght">Calories</label>
                  <tc-input [placeholder]="'Calories'" [type]="'number'" [(ngModel)]="food_dishes_calories"
                     [ngModelOptions]="{standalone: true}" required></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Categories</label>
                  <ng-select [(ngModel)]="food_dishes_category_id" name="food_dishes_category_id" [items]="categories"
                     bindLabel="dish_type_name" bindValue="dish_type_id" [virtualScroll]="true" placeholder="Categories"
                     required>
                  </ng-select>
               </div>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Tags</label>
                  <ng-select [(ngModel)]="tagArray" name="tagArray" [items]="tags" bindLabel="tag_name"
                     bindValue="tag_id" [multiple]="true" [virtualScroll]="true" placeholder="Tags" required>
                  </ng-select>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Allergens</label>
                  <ng-select [(ngModel)]="algns" name="algns" [items]="allergens" bindLabel="allergens_name"
                     bindValue="allergens_id" [multiple]="true" [virtualScroll]="true" placeholder="Allergens" required>
                  </ng-select>
               </div>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Unsuitable Dietary Preference</label>
                  <ng-select [(ngModel)]="dietPref" name="allDiestpref" [items]="allDiestpref"
                     bindLabel="diet_preference_name" bindValue="diet_preference_id" [multiple]="true"
                     [virtualScroll]="true" placeholder="Dietary Preference" required>
                  </ng-select>
               </div>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Allergens Options</label>
                  <ng-select [(ngModel)]="alrgoption" name="alrgoption" [items]="allergens" bindLabel="allergens_name"
                     bindValue="allergens_id" [multiple]="true" [virtualScroll]="true" placeholder="Allergens" required>
                  </ng-select>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Dietary Preference Options</label>
                  <ng-select [(ngModel)]="dietOption" name="dietOption" [items]="allDiestpref"
                     bindLabel="diet_preference_name" bindValue="diet_preference_id" [multiple]="true"
                     [virtualScroll]="true" placeholder="Dietary Preference" required>
                  </ng-select>
               </div>
            </div>
            <div class="col-md-4">
               <tc-form-group class="mb-0 paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Ingredients</label>
                  <tc-textarea [placeholder]="'Ingredients'" [(ngModel)]="ingredience"
                     [ngModelOptions]="{standalone: true}">
                  </tc-textarea>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group class="mb-0" class="paddbottom3">
                  <label for="food_dishes_name" class="fnt-wght">Description</label>
                  <tc-textarea [placeholder]="'Description'" [(ngModel)]="description"
                     [ngModelOptions]="{standalone: true}">
                  </tc-textarea>
               </tc-form-group>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #modalFooter>
      <div class="actions">
         <button tc-button [type]="'button'" [view]="'error'" (click)="closeModal()">Close</button>
         <button tc-button [view]="'info'"
            [disabled]="!food_dishes_name || !food_dishes_price || !food_dishes_category_id"
            (click)="updateList(food_dishes_name,food_dishes_price,food_dishes_spice_rating,food_dishes_calories,food_dishes_category_id,algns,dietPref,ingredience,description,tagArray,alrgoption,dietOption)">
            Update
         </button>
      </div>
   </ng-template>
</ng-container>
<ng-container>
   <ng-template #modalHeader1>
      <h2 class="title">Delete</h2>
   </ng-template>
   <ng-template #modalBody1>
      <p style="font-size: 20px;">Are you sure you want to delete this dish?</p>
   </ng-template>
   <ng-template #modalFooter1>
      <div class="actions">
         <button tc-button [view]="'error'" (click)="closeModals()">Close</button>
         <button tc-button [view]="'success'" (click)="deleteDish()">Delete</button>
      </div>
   </ng-template>
</ng-container>

<ng-container>
   <ng-template #modalHeaderdelete>
      <h2 class="title">Delete</h2>
   </ng-template>
   <ng-template #modalBodydelete>
      <p style="font-size: 20px;">If you delete this file it will get delete permanently and won't be recover in future
      </p>
   </ng-template>
   <ng-template #modalFooterdelete>
      <div class="actions">
         <button tc-button [view]="'error'" (click)="closeModals()">Close</button>
         <button *ngIf="delete_id == 1" tc-button [view]="'success'" (click)="delete_dishImage()">Delete </button>
         <button *ngIf="delete_id == 2" tc-button [view]="'success'" (click)="delete_dishAudio()">Delete </button>
      </div>
   </ng-template>
</ng-container>
<ng-container>
   <ng-template #modalHeaderfile>
      <h2 class="title">Upload CSV File</h2>
   </ng-template>
   <ng-template #modalBodyfile>
      <!-- <button tc-button>Click to upload -->
      <label class="fnt-wght">Select File(CSV only)</label>
      <tc-input type="file" (change)="onCSVChange($event)" [(ngModel)]="disablesCsv"></tc-input>
      <!-- </button> -->
   </ng-template>
   <ng-template #modalFooterfile>
      <div class="actions justify-content-between">
         <button tc-button [view]="'error'" (click)="closeModals()">Close</button>
         <button tc-button [disabled]="!disablesCsv" [view]="'success'" (click)="uploadCsv()">Upload</button>
      </div>
   </ng-template>
</ng-container>
<ng-container>
   <ng-template #modalHeaderImage>
      <h2 class="title">Upload media</h2>
   </ng-template>
   <ng-template #modalBodyImage>
      <tc-form-group class="avatar-box d-flex">
         <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event)" [(ngModel)]="disablesFile"
            #fileInput_image hidden>
         <tc-avatar [src]="currentAvatar"></tc-avatar>
         <button tc-button [type]="'button'" [afterIcon]="'icofont-ui-user'" [tcFontSize]="15" [view]="'accent'"
            [outline]="true" (click)="fileInput_image.click()">
            Select image
         </button>
         &nbsp; &nbsp;
         <button tc-button [disabled]="!disablesFile" [view]="'success'" (click)="uploadImage()">Upload image</button>
         &nbsp; &nbsp; <button *ngIf="currentAvatar" tc-button [view]="'error'"
            (click)="openModalDelete(modalBodydelete, modalHeaderdelete,modalFooterdelete,'1')"> Delete
         </button>
      </tc-form-group>
      <div class="row" style="justify-content: center;">
         <span class="filemessage">{{ messageFilesize}}</span>
      </div>
      <div align="center">
         <tc-form-group class="avatar-box d-flex">
            <input type="file" accept=".mp3" (change)="onaudioChange($event)" [(ngModel)]="disablesFileaudio" #fileInput
               hidden>
            <button style="margin-left: 62px !important;" tc-button [type]="'button'" [afterIcon]="'icofont-audio'"
               [tcFontSize]="15" [view]="'accent'" [outline]="true" (click)="fileInput.click()">Select audio</button>
            &nbsp; &nbsp;
            <button tc-button [disabled]="!disablesFileaudio" [view]="'success'" (click)="uploadAudio()">Upload
               audio</button>
            &nbsp; &nbsp;
            <button *ngIf="audio_file" tc-button [view]="'error'"
               (click)="openModalDelete(modalBodydelete, modalHeaderdelete,modalFooterdelete,'2')">
               Delete </button>
         </tc-form-group>
      </div>
      <div class="row">
         <div class="col-4" *ngIf="audio_file">
            <audio style="width: 357px;" [src]="audio_file" controls controlsList="nodownload"></audio>
         </div>
         <div class="col-8" style="color: #336cfb !important; font-weight: 600; margin-left: 17px;">
            <p>{{file_name}}</p>
         </div>
      </div>
      <div class="row" style="justify-content: center;">
         <span class="filemessage">{{ messageFilesize}}</span>
      </div>
   </ng-template>
</ng-container>
<ng-container>
   <ng-template #Header_addon>
      <h2 class="title">Create {{text}}</h2>
      <img src="../../../assets/img/close-svgrepo-com.svg" style="max-width: 30px; cursor: pointer; "
         (click)="closeModal()">
   </ng-template>
   <ng-template #Body_addon>
      <mat-horizontal-stepper>
         <mat-step>
            <h2>Options</h2>
            <form [formGroup]="myForm" *ngIf="myForm">
               <div class="row">
                  <div class="col-md-5">
                     <label for="option_name" class="fnt-wght">Option name</label>
                  </div>
                  <div class="col-md-5">
                     <label for="option_price" class="fnt-wght">price ( £ )</label>
                  </div>
                  <div class="col-md-2 " *ngIf="rdo_id">
                     <label for="option_price" class="fnt-wght">Action</label>
                  </div>
               </div>
               <div formArrayName="persons"
                  *ngFor="let person of serverData; let i = index ;let first = first; let last = last;">
                  <div class="row py-2" [formGroupName]="i">
                     <div class="col-md-5">
                        <tc-input [placeholder]="'Option name'" [type]="'text'" formControlName="option_name" required>
                        </tc-input>
                     </div>
                     <div class="col-md-5">
                        <tc-input [placeholder]="'Option price'" [type]="'number'" step="1" min="0"
                           formControlName="option_price"
                           onkeydown="return event.keyCode !== 69 && event.keyCode !== 189" required></tc-input>
                     </div>
                     <div class="col-md-2">
                        <button *ngIf="person.option_id" tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10"
                           [view]="'error'" [square]="true" [tcShape]="500" [size]="'sm'"
                           (click)="delete_option(person.option_id)"></button>
                        <button *ngIf="!person.option_id" tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10"
                           [view]="'error'" [square]="true" [tcShape]="500" [size]="'sm'"
                           (click)="delete_option_new(i)"></button>
                        <!-- <ng-container *ngFor ="let item of serverData; let i=index;">
                              <button  *ngIf="!person.option_id" tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10"
                              [view]="'error'" [square]="true" [tcShape]="500" [size]="'sm'"
                              (click)="remove_value(i)"></button> 
                           </ng-container> -->

                        &nbsp;

                        <button *ngIf="last  && i !=4" tc-button [afterIcon]="'icofont-plus'" [tcFontSize]="10"
                           [tcBgColor]="'#64b5f6'" [square]="true" [tcShape]="500" [size]="'sm'"
                           (click)="add_value()"></button>
                     </div>
                  </div>
               </div>
               <br>
               <button tc-button [tcBgColor]="'#64b5f6'" class="float-right next" [disabled]="!myForm.valid"
                  (click)="updateClick()" matStepperNext>Update Varient</button>
               <button tc-button [tcBgColor]="'#64b5f6'" class="float-right next" [disabled]="!myForm.valid"
                  (click)="submitClick()" matStepperNext>Update & Move To Addon</button>
            </form>
         </mat-step>
         <mat-step [stepControl]="secondFormGroup">
            <h2 *ngIf="!Empty_addon">Addon</h2>
            <form #f="ngForm" (ngSubmit)="login(f.valid)" *ngIf="!Empty_addon">
               <div class="row">
                  <div class="col-12">
                     <div class="wrapper">
                        <div>
                           <label for="" class="fnt-wght">Select Add-ons</label>
                        </div>
                        <div *ngFor="let data of displayDish ; let i = index ;let first = first; let last = last;">
                           <label for="" class="fnt-wght">{{data.rdo_option_name}}( £ )</label>
                        </div>
                        <div class="actions">
                           <label for="" class="fnt-wght">Actions</label>
                        </div>
                     </div>
                     <br>
                  </div>
               </div>
               <div class="row" *ngFor="let value of dishOption ; let i = index ;let first = first; let last = last;">
                  <div class="col-12">
                     <div class="wrapper">
                        <div>
                           <ng-select [(ngModel)]="value.addon_id" [ngModelOptions]="{standalone: true}" name="h{{i}}"
                              [virtualScroll]="true" placeholder="select addon" [items]="addonListarray"
                              bindLabel="addon_name" bindValue="restaurant_addon_id" [multiple]="false" #h="ngModel"
                              required></ng-select>
                           <ng-container *ngIf="h.errors?.required && h.touched && submitted"
                              class="alert alert-danger">
                              <p [ngStyle]="{'color': check}">Addon name is required</p>
                           </ng-container>
                        </div>
                        <div *ngFor="let item of value.dishOptions ; ">
                           <tc-input [placeholder]="'Price'" name="Y{{i}}" [(ngModel)]="item.rdo_option_addOn_price"
                              [ngModelOptions]="{standalone: true}" #h="ngModel" [type]="'number'" step="1" min="1"
                              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189" required>
                           </tc-input>
                           <ng-container *ngIf="h.errors?.required && h.touched && submitted"
                              class="alert alert-danger">
                              <p [ngStyle]="{'color': check}">Price is required </p>
                           </ng-container>
                        </div>
                        <div class="actions">
                           <button *ngIf="value.addon_id" tc-button [afterIcon]="'icofont-ui-delete'"
                              (click)="remove_Addon(value.dish_addon_id)" [tcFontSize]="10" [view]="'error'"
                              [square]="true" [tcShape]="500" [size]="'sm'"></button> &nbsp;
                           <button *ngIf="last" tc-button [afterIcon]="'icofont-plus'" (click)="add_ADDon(i)"
                              [tcFontSize]="10" [tcBgColor]="'#64b5f6'" [square]="true" [tcShape]="500"
                              [size]="'sm'"></button>
                        </div>
                     </div>
                     <br>
                  </div>
               </div>
               <br>
               <br>
               <br>
               <button tc-button [tcBgColor]="'#ed5564'" class="float-right next" matStepperPrevious
                  (click)="backFunc()">Back</button>
               <button tc-button [tcBgColor]="'#64b5f6'" class="float-right"
                  (click)="create_ADD(dishOption)">Create</button>
            </form>
            <ng-container *ngIf="Empty_addon">
               <h4 align="center">Add-ons not found </h4>
               <button tc-button [tcBgColor]="'#ed5564'" class="float-right next" matStepperPrevious
                  (click)="backFunc()">Back</button>
               <button tc-button [tcBgColor]="'#64b5f6'" class="float-right" (click)="navigate_addon_page()">Create
                  Add-ons</button>
            </ng-container>

         </mat-step>
      </mat-horizontal-stepper>
   </ng-template>
</ng-container>